/**
 * Thin, safe wrappers around localStorage / sessionStorage.
 * - JSON serialize/deserialize transparently
 * - Never throw (storage can be unavailable in private mode / SSR)
 */

const safeParse = (raw) => {
  if (raw === null || raw === undefined) return null;
  try {
    return JSON.parse(raw);
  } catch {
    return raw;
  }
};

const createStorage = (backend) => ({
  get(key) {
    try {
      return safeParse(backend.getItem(key));
    } catch {
      return null;
    }
  },
  set(key, value) {
    try {
      backend.setItem(key, typeof value === 'string' ? value : JSON.stringify(value));
    } catch {
      /* ignore write failures */
    }
  },
  remove(key) {
    try {
      backend.removeItem(key);
    } catch {
      /* ignore */
    }
  },
  clear() {
    try {
      backend.clear();
    } catch {
      /* ignore */
    }
  },
});

export const localStorageUtil = createStorage(
  typeof window !== 'undefined' ? window.localStorage : { getItem() {}, setItem() {}, removeItem() {}, clear() {} }
);

export const sessionStorageUtil = createStorage(
  typeof window !== 'undefined' ? window.sessionStorage : { getItem() {}, setItem() {}, removeItem() {}, clear() {} }
);

export default localStorageUtil;
